import { Injectable } from '@angular/core';
import { Features } from './sub-models/features.model';
import { PayloadTypeEnum, VerifyAccountStateEnum } from './features-data.data';
import { Toggles } from './sub-models/toggles.model';

@Injectable({
  providedIn: 'root',
})
export class FeaturesDataStateService {
  private accountVerifyState(features: Features): string {
    const verifyAccountPayload =
      features.payloads &&
      features.payloads.get(PayloadTypeEnum.verify_account);
    return verifyAccountPayload && verifyAccountPayload.get('state');
  }

  private isVerifyAccountAllAccess(features: Features): boolean {
    return (
      features.toggles &&
      features.toggles.isAllAccess(Toggles.KEYS.VERIFY_ACCOUNT)
    );
  }

  isAccountVerified(features: Features): boolean {
    return (
      this.isVerifyAccountAllAccess(features) &&
      this.accountVerifyState(features) === VerifyAccountStateEnum.none
    );
  }

  isAccountNotified(features: Features): boolean {
    return (
      this.isVerifyAccountAllAccess(features) &&
      this.accountVerifyState(features) === VerifyAccountStateEnum.notify
    );
  }

  isAccountBlocked(features: Features): boolean {
    return (
      this.isVerifyAccountAllAccess(features) &&
      this.accountVerifyState(features) === VerifyAccountStateEnum.force
    );
  }
}
